import client from "./clients/portalClient";

const getAllWatchdogs = () => client.get(`/watchdog_projects`);
const editExistingWatchdog = (id, data) => client.put(`/watchdog_projects/${id}`, data);
const postNewWatchdog = (data) => client.post(`/watchdog_projects`, data);

const watchdogApi = {
  getAllWatchdogs,
  editExistingWatchdog,
  postNewWatchdog,
};

export default watchdogApi;
